// extracted by mini-css-extract-plugin
export default {"homePage":"HomePage_homePage__Z9VOd","jokeBox":"HomePage_jokeBox__45Wj-"};